import { TFunction } from "i18next";

import { IDropDown } from "../../../components/DropdownGlobal";

export const listTranscriptionProviderAux: Array<IDropDown> = [
  { name: "MConf", id: 0 },
  { name: "Digitro", id: 1 },
];

export const getListTimesAux = (t: TFunction): Array<IDropDown> => [
  { name: `30 ${t("constants.minutes")}`, id: 30 },
  { name: `60 ${t("constants.minutes")}`, id: 60 },
];

export const getListDaysAux = (t: TFunction): Array<IDropDown> => [
  { name: `30 ${t("constants.days")}`, id: 30 },
  { name: `60 ${t("constants.days")}`, id: 60 },
];

export const getListFilterPeriodDays = (t: TFunction): Array<IDropDown> => [
  { name: t("constants.today"), id: 0 },
  { name: `1 ${t("constants.day")}`, id: 1 },
  { name: `2 ${t("constants.daysPlural")}`, id: 2 },
  { name: `3 ${t("constants.daysPlural")}`, id: 3 },
  { name: `4 ${t("constants.daysPlural")}`, id: 4 },
  { name: `5 ${t("constants.daysPlural")}`, id: 5 },
  { name: `6 ${t("constants.daysPlural")}`, id: 6 },
  { name: `7 ${t("constants.daysPlural")}`, id: 7 },
];

export const getListProviderAux = (t: TFunction): Array<IDropDown> => [
  { name: "Azure", id: 0 },
  { name: t("constants.fileSystem"), id: 1 },
];

export const getListFirstShortcut = (t: TFunction): Array<IDropDown> => [
  { name: t("constants.none"), id: 0 },
  { name: "Alt", id: 1 },
  { name: "Shift", id: 2 },
  { name: "Ctrl", id: 3 },
];

export const getResetPasswordDays = (t: TFunction): Array<IDropDown> => [
  { name: t("constants.indefinite"), id: 0 },
  { name: "10", id: 10 },
  { name: "20", id: 20 },
  { name: "30", id: 30 },
  { name: "40", id: 40 },
  { name: "50", id: 50 },
];

export const listPagination: Array<IDropDown> = [
  { name: "5", id: 5 },
  { name: "10", id: 10 },
  { name: "20", id: 20 },
  { name: "50", id: 50 },
  { name: "100", id: 100 },
];

export const getListYesOrNoAux = (t: TFunction): Array<IDropDown> => [
  { name: t("common.no"), id: 0 },
  { name: t("common.yes"), id: 1 },
];

export const loginConfigAttemptAux: Array<IDropDown> = [
  { name: "3", id: 3 },
  { name: "5", id: 5 },
  { name: "7", id: 7 },
];

export const loginConfigPeriodAttemptsAux: Array<IDropDown> = [
  { name: "10", id: 10 },
  { name: "20", id: 20 },
  { name: "30", id: 30 },
];

export const getListSecondShortcut = (t: TFunction): Array<IDropDown> => [
  { name: t("constants.space"), id: 0 },
  { name: "F1", id: 1 },
  { name: "F2", id: 2 },
  { name: "F3", id: 3 },
  { name: "F4", id: 4 },
  { name: "F5", id: 5 },
  { name: "F6", id: 6 },
  { name: "F7", id: 7 },
  { name: "F8", id: 8 },
  { name: "F9", id: 9 },
  { name: "F10", id: 10 },
  { name: "F11", id: 11 },
  { name: "F12", id: 12 },
  { name: t("constants.arrowLeft"), id: 13 },
  { name: t("constants.arrowUp"), id: 14 },
  { name: t("constants.arrowRight"), id: 15 },
  { name: t("constants.arrowDown"), id: 16 },
];

export const getListSecondsToNextBack = (t: TFunction): Array<IDropDown> => [
  { name: `5 ${t("constants.seconds")}`, id: 5 },
  { name: `10 ${t("constants.seconds")}`, id: 10 },
  { name: `20 ${t("constants.seconds")}`, id: 20 },
  { name: `30 ${t("constants.seconds")}`, id: 30 },
  { name: `60 ${t("constants.seconds")}`, id: 60 },
];

//Digitro = Provedor 1, Kenta = Provedor 2
export const getListWaterMarkProvider = (t: TFunction): Array<IDropDown> => [
  //   { name: t("constants.provider1"), id: 0 },
  { name: `${t("constants.provider")} 2`, id: 1 },
];

export const getEditConfig = (t: TFunction): Array<IDropDown> => [
  { name: `${t("constants.provider")} 1`, id: 1 },
  { name: `${t("constants.provider")} 2`, id: 2 },
  { name: `${t("constants.provider")} 3`, id: 3 },
];

//1 - Digitro - Provedor 1 | 2 - MConf - Provedor 2 | 3 - Offline - Provedor 3
export const getListRecordProvider = (t: TFunction): Array<IDropDown> => [
  // { name: `${t("constants.provider")} 1`, id: 1 },
  { name: `${t("constants.provider")} 2`, id: 2, enabled: true },
  {
    name: `${t("constants.provider")} 3`,
    id: 3,
    enabled: import.meta.env.VITE_OFFLINE_RECORD_PROVIDER_ENABLED === "true",
  },
];

export const getListMfaTypeAux = (t: TFunction): Array<IDropDown> => [
  { name: "E-mail", id: 1 },
  { name: `TOTP (${t("constants.authenticatorApp")})`, id: 2 },
];

export const listExpireInHearingFileUrlHours: Array<IDropDown> = [
  { name: "1", id: 1 },
  { name: "2", id: 2 },
  { name: "3", id: 3 },
  { name: "4", id: 4 },
  { name: "5", id: 5 },
  { name: "6", id: 6 },
  { name: "7", id: 7 },
  { name: "8", id: 8 },
  { name: "9", id: 9 },
  { name: "10", id: 10 },
  { name: "11", id: 11 },
  { name: "12", id: 12 },
  { name: "13", id: 13 },
  { name: "14", id: 14 },
  { name: "15", id: 15 },
  { name: "16", id: 16 },
  { name: "17", id: 17 },
  { name: "18", id: 18 },
  { name: "19", id: 19 },
  { name: "20", id: 20 },
  { name: "21", id: 21 },
  { name: "22", id: 22 },
  { name: "23", id: 23 },
  { name: "24", id: 24 },
];

export const listExpireInHearingFileUrlDays: Array<IDropDown> = [
  { name: "1", id: 1 },
  { name: "2", id: 2 },
  { name: "3", id: 3 },
  { name: "7", id: 7 },
  { name: "15", id: 15 },
  { name: "30", id: 30 },
  { name: "45", id: 45 },
  { name: "60", id: 60 },
  { name: "90", id: 90 },
  { name: "180", id: 180 },
];
